import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DashboardServiceService } from '../../services/dashboard-service.service';

@Component({
  selector: 'app-end-subscription-add-ons',
  templateUrl: './end-subscription-add-ons.component.html',
  styleUrls: ['./end-subscription-add-ons.component.css'],
})
export class EndSubscriptionAddOnsComponent implements OnInit {
  completeData: any;
  outReach: any;
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dashboard: DashboardServiceService
  ) {
    //modal to end addons
  }

  ngOnInit(): void {
    this.outReach = this.data.outReach;
    this.completeData = this.data.completeData;
  }

  noActionDIalog(): void {
    this.dialog.closeAll();
  }


  //unsubscribing addons through modal
  unSubscribe(): void {
    const body: any = {
      update_seats: {},
    };
    for (let i = 0; i < this.completeData.length; i++) {
      if (
        this.completeData[i].change != this.completeData[i].original &&
        this.completeData[i].name == 'Collaborator Seats'
      ) {
        body.update_seats[this.completeData[i].plan_code] =
          this.completeData[i].change;
      }
    }
    if (this.outReach) {
      body.remove_subscription = [this.outReach];
    } else {
      body.remove_subscription = [];
    }
    this.dashboard.editAdOns(body).subscribe(() => {
      this.dialog.closeAll();
      this.dashboard.clear(true);
    });
  }
}
